var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "22px",
    viewBox: "0 0 21 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pin icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-0.4%",
    y: "-0.2%",
    width: "100.9%",
    height: "100.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.823529412   0 0 0 0 0.823529412   0 0 0 0 0.823529412  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Posts",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-page_Show-All-Comments",
    transform: "translate(-866.000000, -1064.000000)",
    stroke: "#49853F"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(115.000000, 65.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Middle",
    transform: "translate(211.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Posts-List",
    filter: "url(#filter-1)",
    transform: "translate(0.000000, 929.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Post-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pin",
    transform: "translate(537.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pin-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pin_icon-14*24",
    transform: "translate(12.000000, 12.000000) rotate(45.000000) translate(-12.000000, -12.000000) translate(6.000000, 1.714286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_Jee-49_2180760"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.61461257,15.280965 L6.61461257,13.20228 L11.7092503,13.20228 C11.7172389,13.153371 11.7172389,13.096307 11.7172389,13.047398 C11.7172389,12.749996 11.6581714,12.453574 11.5438286,12.180007 C11.4326194,11.91393 11.2701737,11.670841 11.0689097,11.46726 C10.9066217,11.303103 10.721808,11.172476 10.5212091,11.062219 C10.328688,10.9564 10.1018263,10.915401 9.89708571,10.832836 C9.312432,10.597062 8.74475657,10.243569 8.34516343,9.741004 C8.15063314,9.496347 8.18773029,9.260629 8.18773029,8.964431 C8.18773029,8.768963 8.18773029,8.573502 8.18773029,8.378034 C8.18773029,8.137059 8.18773029,7.896091 8.18773029,7.655116 C8.18773029,7.387485 8.18773029,7.119854 8.18773029,6.852223 C8.18773029,6.576787 8.18773029,6.301351 8.18773029,6.025915 C8.18773029,5.761525 8.18773029,5.497142 8.18773029,5.232752 C8.18773029,4.998266 8.18773029,4.763773 8.18773029,4.529287 C8.18773029,4.343549 8.18773029,4.157811 8.18773029,3.97208 C8.18773029,3.836784 8.18786743,3.701495 8.18716114,3.566206 C8.18671543,3.480344 8.25357257,3.400397 8.29898057,3.331517 C8.35202743,3.251059 8.40990171,3.173905 8.472288,3.100755 C8.59590857,2.955799 8.73732343,2.826684 8.89285714,2.718324 C9.01323429,2.63445 9.14133943,2.562427 9.27416914,2.501303 C9.39022629,2.447893 9.51602057,2.424415 9.63887314,2.39344 C9.759792,2.362955 9.87065829,2.311554 9.96881143,2.23216 C10.1000983,2.12597 10.2025371,1.983688 10.2615703,1.823598 C10.3000526,1.719228 10.319808,1.60797 10.319808,1.49646 C10.319808,0.982905 9.90457371,0.55902 9.40149943,0.55902 L8.18773029,0.55902 L4.11521829,0.55902 L2.93338286,0.55902 C2.43591771,0.559027 2.01508114,0.988596 2.01507429,1.49646 C2.01507429,1.868979 2.24724343,2.214506 2.58329829,2.356935 C2.64373714,2.382548 2.70698057,2.40128 2.77149257,2.412529 C2.95562743,2.444638 3.12336,2.532173 3.28350171,2.629711 C3.43741029,2.723455 3.58093029,2.83493 3.70904914,2.962946 C3.79783543,3.051664 3.87900343,3.148271 3.95184,3.25101 C4.01489829,3.339952 4.11656229,3.45807 4.11586971,3.572128 C4.11473143,3.758769 4.11521143,3.945431 4.11521143,4.132086 C4.11521143,4.336745 4.11521143,4.541404 4.11521143,4.746063 C4.11521143,4.993555 4.11521143,5.24104 4.11521143,5.488532 C4.11521143,5.759572 4.11521143,6.030605 4.11521143,6.301645 C4.11521143,6.576948 4.11521143,6.852251 4.11521143,7.127554 C4.11521143,7.387842 4.11521143,7.64813 4.11521143,7.908418 C4.11521143,8.134406 4.11521143,8.360394 4.11521143,8.586382 C4.11521143,8.758792 4.11521143,8.931202 4.11521143,9.103605 C4.11521143,9.289182 4.13561143,9.450336 4.02519086,9.609782 C3.60912,10.210578 2.93084571,10.655071 2.25462857,10.887198 C1.87133486,10.993171 1.535952,11.196962 1.26445029,11.465965 C0.873168,11.873547 0.625625143,12.436018 0.625625143,13.047391 C0.625625143,13.0963 0.625625143,13.153364 0.633613714,13.202273 L5.77616229,13.202273 L5.77616229,15.280951",
    id: "Shape",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    strokeWidth: 0.7,
    points: "5.77615543 13.20228 5.77615543 15.280965 5.77615543 17.995474 6.19937829 20.44098 6.61461257 17.995474 6.61461257 15.280965 6.61461257 13.20228"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    strokeWidth: 0.7,
    points: "11.7092503 13.20228 6.61461257 13.20228 5.77615543 13.20228 0.633606857 13.20228"
  })))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/icon-pin.cf7b8bbb270c7fd9ed11e49efbe35177.svg";
export { ForwardRef as ReactComponent };